import { Messages } from '../../../../codegen/Localize';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { changeRemoteExtractRefresh } from '../../../actions/spaces/ChangeRemoteExtractRefreshAction';
import { selectSpaceInfoItem } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { currentUserIsOwnerOrAdmin } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeRemoteExtractRefreshEntityAction:
  IEntityAction<IRemoteRefreshScheduleInfo, any> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.editRemoteRefreshSchedule_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: (items: IRemoteRefreshScheduleInfo[]) => changeRemoteExtractRefresh(items[0])
};

function isClickable(
  availableActions: any,
  schedules: IRemoteRefreshScheduleInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
